import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import EntityManagementScreen from '../common/EntityManagementScreen';

const PortalPostManagementScreen = () => {
  const navigate = useNavigate();

  return (
    <EntityManagementScreen
      entityName="PortalPost"
      beautifulName="Portal Post"
      onCreateClick={() => navigate('/settings/portal_posts/create')}
      onEditClick={(id) => navigate(`/settings/portal_posts/edit/${id}`)}
      extraHeaderActions={(
        <Button
          type="primary"
          size="large"
          icon={<PlusOutlined />}
          onClick={() => navigate('/settings/portal_posts/create')}
        >
          Create Portal Post
        </Button>
      )}
    />
  );
};

export default PortalPostManagementScreen;
